import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import CreateAccountForm from './CreateAccountForm';
import Container from '../../ui/Container';
import Footer from '../../ui/Footer';
import LarsImage from '../../ui/LarsImage';
import Layout from '../../ui/Layout';
import SectionWrap from '../../ui/SectionWrap';
import styled from 'styled-components';
import { useForm, FormProvider } from 'react-hook-form';
import config from '../../config';
import colors from '../../ui/constants/colors';
import setCapterraConversionTrackingPixel from '../../vendor/capterraConversionTracking';
import Header from '../../ui/Header';

const Form = styled.form`
  all: unset;
`;

const AgreementBlurb = styled.div`
  font-size: 14px;
  color: ${colors.cyberSpace};
  a {
    color: ${colors.electricBlue};
    text-decoration: none;
    transition: all 0.125s ease-out;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const CreateAccount = ({ client, handleCreateAccountSubmit, isLoading, history, hasTopBanner }) => {
  useEffect(() => {
    setCapterraConversionTrackingPixel();
  }, []);

  const methods = useForm();
  const { handleSubmit } = methods;

  const onSubmit = payload => {
    handleCreateAccountSubmit({
      client,
      payload,
      redirect: history.push,
    });
  };

  const createPayload = ({ firstName, lastName, email, password }) => ({
    firstName: firstName,
    lastName: lastName,
    email: email,
    password: password,
  });

  return (
    <FormProvider {...methods}>
      <Form onSubmit={handleSubmit(fieldValues => onSubmit(createPayload(fieldValues)))}>
        <Layout>
          <Layout.Sidebar>
            <LarsImage />
          </Layout.Sidebar>
          <Layout.Page hasSidebar hasTopBanner={hasTopBanner}>
            <SectionWrap>
              <Container minWidth="580px" topPadding="32px">
                <Header
                  headerText="Create your Bench account - you’ll need this for your free demo."
                  subHeaderText="Review your account details and create a password."
                />
                <CreateAccountForm isLoading={isLoading} client={client} />
                <AgreementBlurb>
                  <p>
                    By signing up you accept our{' '}
                    <a
                      href={`${config.WEBSITE_URL}/terms/`}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      End User License Agreement and Terms of Service
                    </a>
                    .
                  </p>
                </AgreementBlurb>
              </Container>
            </SectionWrap>
          </Layout.Page>
          <Layout.Footer hasSidebar>
            <Footer
              hasNext
              isLoading={isLoading}
              onClickNext={handleSubmit}
              text="Create Account"
            />
          </Layout.Footer>
        </Layout>
      </Form>
    </FormProvider>
  );
};

export default CreateAccount;

CreateAccount.propTypes = {
  isLoading: PropTypes.bool,
  client: PropTypes.object.isRequired,
  handleCreateAccountSubmit: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  hasTopBanner: PropTypes.bool.isRequired,
};

CreateAccount.defaultProps = {
  isLoading: false,
};
